import { Checkbox, FlexCell, FlexRow, Text } from '@epam/promo';
import { useUserRole } from 'hooks/helpers';
import { UserManagementControl } from '../UserManagementControl';
import { BASE_COLOR, COLORS, ColorTypes } from './constants';
import { UserManagementCardProps } from './UserManagementCard.model';
import css from './UserManagementCard.module.scss';

export const UserManagementCard = ({
  userEmail,
  selected = false,
  handleSelect,
  handleDelete,
}: UserManagementCardProps) => {
  const { isSuperAdmin } = useUserRole();
  const userInitial = userEmail[0].toUpperCase();
  const randomBGColor = COLORS[userInitial as keyof ColorTypes] ?? BASE_COLOR;

  return (
    <FlexRow cx={css['user-management-card']}>
      {isSuperAdmin && (
        <Checkbox
          cx={css['user-management-card__checkbox-container']}
          label={
            <div className={css['user-management-card__checkbox']}>
              <div className={css['user-management-card__name']}>
                <div
                  className={css['user-management-card__avatar']}
                  style={{ backgroundColor: randomBGColor }}>
                  {userInitial}
                </div>
                <Text color="gray80" size="24">
                  {userEmail}
                </Text>
              </div>
              <FlexCell cx="delete-icon">
                <UserManagementControl handleDelete={handleDelete} />
              </FlexCell>
            </div>
          }
          value={selected}
          onValueChange={() => handleSelect(userEmail)}
        />
      )}
      {!isSuperAdmin && (
        <div className={css['user-management-card__name']}>
          <div
            className={css['user-management-card__avatar']}
            style={{ backgroundColor: randomBGColor }}>
            {userInitial}
          </div>
          <Text color="gray80" size="24">
            {userEmail}
          </Text>
        </div>
      )}
    </FlexRow>
  );
};
